<template>
  <div class="role-info-contianer">
    {{ letter.storeWelcome }}：
    <span class="server-info">
      {{ getCurServerName(serverId) }}
    </span>
    -
    <span class="role-info"> {{ roleName }}</span>
    <div
      type="reselectRole"
      class="reselect-role j-reselect-role"
      @click="scrollToCharSelect"
    >
      {{ letter.switchChar }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
export default {
  props: ['serverId'],
  computed: {
    ...mapState({
      letter: state => state.letter,
      serverList: state => state.serverList,
      roleName: state => state.roleName
    })
  },
  methods: {
    getCurServerName(id) {
      let res = '';
      if (!this.serverList) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == id) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    },
    scrollToCharSelect() {
      window.scrollTo({ top: 400 });
      clickButton({
        btnName: 'select_role',
        locationKey: locationType.accountInfo
      });
    }
  }
};
</script>

<style scoped lang="scss">
$h: 66px;
$f: 24px;
.role-info-contianer {
  display: flex;
  position: fixed;
  top: 88px;
  z-index: 12;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-left: 25px;
  width: 100%;
  height: $h;
  background: var(--login-role-info-bg);
  text-align: center;
  font-size: 24px;
  color: var(--login-role-info);
  .server-info,
  .role-info {
    display: inline-block;
    overflow: hidden;
    max-width: 42%;
    text-overflow: ellipsis;
    font-size: $f;
    white-space: nowrap;
  }
  .reselect-role {
    position: absolute;
    right: 25px;
    top: 50%;
    cursor: pointer;
    font-size: 24px;
    color: var(--login-role-switch);
    transform: translateY(-50%);
  }
}
@media screen and (orientation: landscape) {
  .role-info-contianer {
    left: 50%;
    width: 1202px;
    transform: translateX(-50%);
  }
}
</style>
